"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("app/models");
const parseFile_1 = require("@/utils/parseFile");
const parseFile_2 = require("utils/parseFile");
const firestore_web_1 = require("comodel/firestore-web");
const standard_1 = require("react-hook-schema/standard");
exports.default = ({ isEditing, projectId, segmentId, langAliases, }) => {
    return {
        schemaType: "object",
        properties: [],
    };
};
function composeBook(fileName, projectId, segmentId, option) {
    return __awaiter(this, void 0, void 0, function* () {
        const file = yield (0, standard_1.getFile)(fileName);
        if (!file) {
            return null;
        }
        // FIXME: reported by Shōsei Yū <4kizuki@h4dz.io>
        //        What if the file was CSV?
        const workbook = yield (0, parseFile_1.readExcel)(file);
        const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId }, {
            filter: { segmentId },
        });
        const records = yield accessor.get();
        yield (0, parseFile_1.writeTranslation)(workbook, records, option);
        // This code is to "COMMIT" changes. Without this, changed cells are not readable (can not read affected rows)
        return yield (0, parseFile_1.readExcel)((0, parseFile_2.bookToBlob)(workbook));
    });
}
